<template>
    <div class="py-5">
        <div class="row">
            <div class="col-12">
            <p class="pb-3 mb-sm-2 text-center text-muted">Paynet el sistema para procesamiento de pagos en efectivo en tiendas</p>
            </div>
            <div class="col-12">
                <a class="btn btn-info mb-5 py-2" data-toggle="collapse" href="#collapsePaynetStore" role="button" aria-expanded="false" aria-controls="collapseExample">
                Tiendas aceptadas ↕
                </a>
            </div>
            <div class="collapse" id="collapsePaynetStore">
                <div class="col-12">
                    <p class="mb-1 mb-sm-2 text-left">
                        Tiendas afiliadas a la Red Paynet
                    </p>
                    <div class="row mb-5 d-flex flex-wrap align-items-center justify-content-start">
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/f_benavides.jpg" alt="Farmacias benavides" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/7eleven.png" alt="7Eleven" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/Walmart.png" alt="Walmart" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/f_ahorro.png" alt="Farmacias del ahorro" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/sams.png" alt="Sams" class="img-fluid" width="40px" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/Superama.png" alt="Superama" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/Bodega-Aurrera.png" alt="Bodega aurrera" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/Circle_K.jpg" alt="Circle k" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/Asturiano.png" alt="Asturiano" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/CircleK_2.jpg" alt="Circle k" class="img-fluid" width="30px" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/Waldos.png" alt="Waldos" class="img-fluid" width="40px" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/alsuper.jpeg" alt="alsuper" class="img-fluid" width="80px" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/Extra.png" alt="Extra" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/Kiosko.jpg" alt="Kiosko" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/f_guadalajara.jpg" alt="Farmacias Guadalajara" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/gestoPago.jpg" alt="Gesto pago" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/aTiendas.jpg" alt="ATiendas" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/multiRecargas.jpg" alt="Multi recargas" class="img-fluid" height="auto"></div>
                        <div class="col-4 col-md-3 col-lg-2 py-1"><img loading="lazy" src="images/img_openPay/pagoRapido.jpg" alt="Pago rapido" class="img-fluid" height="auto"></div>
                    </div>
                </div>
            </div>
            <div class="col-12 p-0">
                <ul class="list-group">
                    <li class="list-group-item d-flex justify-content-between align-items-start">
                        <span class="mt-1 badge badge-success badge-pill">1</span>
                        <p class="pl-3 text-left w-100">Elige pago en efectivo como método de pago</p>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-start">
                        <span class="mt-1 badge badge-success badge-pill">2</span>
                        <p class="pl-3 text-left w-100">Recibe el numero de referencia de pago (puede ser electronica o impresa)</p>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-start">
                        <span class="mt-1 badge badge-success badge-pill">3</span>
                        <p class="pl-3 text-left w-100">Imprímelo y présentalo en caja para realizar tu pago en cualquiera de las tiendas afiliadas dentro de las próximas 72 horas.</p>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-start">
                        <span class="mt-1 badge badge-success badge-pill">4</span>
                        <p class="pl-3 text-left w-100">Inmediatamente después de recibir tu pago te enviaremos una notificacion de la confirmación de pago.</p>
                    </li>
                </ul>
            </div>
            <div class="w-100 text-end pt-2">
                Transacciones realizadas via: <img src="images/img_openPay/logo_paynet.png" alt="paynet" class="img-responsive" width="100" height="auto"><br>
            </div>
        </div>
    </div>     
</template>

<script>
const axios = require("axios");

    export default {
          name: "OpenPayPaynet",
          props: ['api_url','products','addressData','receiver','codeCoupon'],
          data(){
            return {
                local_url: process.env.VUE_APP_SUSCRIPTIONS_LOCAL_ROUTE,
                itemPrice:null
            }
          },
          methods:{
              sendDataPaynet: function(){
                // Consulta referencia de pago paynet
                axios({
                    method: "POST",
                    url: this.api_url + "/payment/store",
                    data: {
                        user_id: $cookies.get("uidmmkg"),
                        items: this.products,
                        address: this.addressData,
                        address_id: this.addressData.id,
                        receiver: this.receiver,
                        code: this.codeCoupon
                    },
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + $cookies.get("utoken"),
                    },
                }).then((response) => {
                    if (response.data.status) {
                        // Redireccionamiento a el pdf con la referencia generada
                        window.open(response.data.payment_url, "_blank");
                        
                        window.dataLayer.push({
                            'event': 'Pago',
                            'pageURL': this.$router.currentRoute.fullPath,
                            'product': this.products,
                            'months': "",
                            'address': this.addressData,
                            'paymentMethod': "El metodo de pago es por referencia de pago Paynet en tiendas",
                            'datePayment': new Date().toLocaleString('en-US')
                        });
                        // Redireccionamiento a la ficha de pago y agradecimiento
                        console.log(response);
                        this.$router.push({
                            name: "thanksForPay",
                            params: {
                                validate: true,
                                products: this.products
                            },
                        });
                        // Se vacia el carrito 
                        this.$store.commit('finishStore');
                        
                    }else{
                        // se actualiza el estado de el loader y el boton de el componente padre checkout.vue
                        this.$emit('updateStates', false, false);
                        this.$snotify.error("Sucedió un error en la transacción");
                    }
                }).catch((error) => {
                    console.log(error);
                    this.$emit('updateStates', false, false);
                    this.$snotify.error(error);
                });
              },
          },
          created(){
            //   Escucha el tipo de pago a ejecutar paynet en este caso desde el checkout.vue
              this.$parent.$on('paynetMethod', this.sendDataPaynet);
          },
          mounted(){
                console.log('paynet montado');
          }
    }
</script>

<style lang="scss" scoped>
img{
    image-rendering:-webkit-optimize-contrast; /* Safari         */
    image-rendering:optimize-contrast;         /* CSS3 Proposed  */
    -ms-interpolation-mode:nearest-neighbor;   /* IE8+           */
}
</style>